import script from "./StatusVideoLink.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusVideoLink.vue?vue&type=script&setup=true&lang=js"

import "./StatusVideoLink.vue?vue&type=style&index=0&id=27c6f842&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c6f842"]])

export default __exports__